import { connect } from 'react-redux';
import MFilterLessOrderComponent from './MFilterLessOrderComponent';
import { Dispatch , AnyAction } from 'redux';
import { AppState } from '../../redux';
import { rowClick, downloadURL, onbulkDownload, approvalRequired, onBulkDownloadStl, onBulkDownloadIndividual } from 'src/actions/completeOrderAction';
import { RowDataCompleted } from 'src/reducers/completeorderfile';
import { rework } from 'src/actions/liveOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { getCustDataFilter, getMInproductionOrderData, getMInproductionOrderDataFilterLess, getPreviewData, resetPreviewData, stopTimerProductionStatus } from 'src/actions/manufacturAction';
import { push } from 'react-router-redux';
import { orderno, orderDisabled } from 'src/actions/supportAction';
import { downloadAttachment } from 'src/actions/rxformAction';
import { renderSTLImage } from 'src/actions/stlViewerAction';
import { GetFileData } from 'src/reducers/rxForm';
import { openVideoPlayerURLArray } from 'src/actions/landingPageAction';
import { SHOW_FAILED_FILES_DIALOG } from '../../reducers/completeorderfile';

// import { push } from 'react-router-redux';
// import {
//     saveFeedbackType,
//     saveCommands,
//     doFeedback
// } from '../../actions/feedbackAction';

export const mapStateToProps = (state: AppState) => {
    return {

        userDetails: state.user.userDetails,

        mfilteredOrderData: state.manufactur.mfilterLessOrderData,
        mfiltersdataExport: state.manufactur.mfiltersdataExport,
        isDownloading: state.completeOrder.isDownloading,
        redesignReasons: state.completeOrder.redesignReasons,
        orderDataTat: state.fileUpload.orderDataTat,
        orderDataManufacturer: state.fileUpload.orderDataManufacturer,

        previewOrderData: state.manufactur.previewOrderData,
        // New properties for failed files dialog
        failedFiles: state.completeOrder.failedFiles,
        showFailedFilesDialog: state.completeOrder.showFailedFilesDialog,
        failedFilesMessage: state.completeOrder.failedFilesMessage,
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getRedesignReasons);
            dispatch(getMInproductionOrderDataFilterLess('', '', new Date(), new Date(), 'ALL'));
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
        },
        onComponentWillUnMount: () => {
            dispatch(stopTimerProductionStatus);
        },
        reload: () => {
            dispatch(getMInproductionOrderDataFilterLess('', '', new Date(), new Date(), 'ALL'));
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Final Scan'));
        },
        onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onbulkDownload(completedData, true));
        },
        onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => {
            dispatch(onBulkDownloadStl(completedData, filetype, true));
        },
        onBulkDownloadIndividual: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onBulkDownloadIndividual(completedData, true));
        },
        approvalRequired: (array: Array<object>) => {
            dispatch(approvalRequired(array));
        },
        redesignRequest: (columns: Object) => {
            dispatch(rework(columns, 'mfilter'));
        },
        dateFilter: () => {
            dispatch(getMInproductionOrderData);
        },
        dateReset: () => {
            dispatch(getMInproductionOrderData);
        },
        caseFilter: (fcaseno: string, tcaseno: string, startDate: Date | null, endDate: Date | null, status: string) => {
            dispatch(getMInproductionOrderDataFilterLess(fcaseno, tcaseno, startDate, endDate, status));
        },
        caseFilterCust: (fcaseno: string, tcaseno: string) => {
            dispatch(getCustDataFilter(fcaseno, tcaseno));
        },
        downloadFile: (filepath: string, filename: string, status: string) => {
            dispatch(downloadURL(filepath, filename, status));
        },
        supportPage: (order: string) => {
            dispatch(orderno(order));
            dispatch(orderDisabled(true));
            dispatch(push('/app/support'));
        },
        getPreviewData: (ordernum: string) => {
            dispatch(getPreviewData(ordernum));
        },
        resetPreviewData: () => {
            dispatch(resetPreviewData);
        },
        msgAtt: (msgAttachment: string) => {
            dispatch(downloadAttachment(msgAttachment));
        },
        goStlViewer: (data: GetFileData[]) => {
            dispatch(renderSTLImage(data));
        },
        openVideoPlayerURL: (fullPath: string[], fpath: string) => {
            dispatch(openVideoPlayerURLArray(fullPath, fpath));
        },
         closeFailedFilesDialog: () => {
            dispatch({ type: SHOW_FAILED_FILES_DIALOG, showFailedFilesDialog: false } as AnyAction);
        },
    };
};

const MFilterLessOrderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MFilterLessOrderComponent);

export default MFilterLessOrderContainer;



// WEBPACK FOOTER //
// ./src/components/MFilterLessOrder/MFilterLessOrderContainer.tsx